import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PortalTooltip from '../../../common/portal-tooltip/PortalTooltip';
import { I18n } from 'react-redux-i18n';

const lines = [
  {
    value: -2,
    name: '-2 StDv',
    color: '#eb505a',
    tooltip: 'marketInDepthValuation.avgSub2Std',
  },
  {
    value: -1,
    name: '-1 StDv',
    color: '#f88634',
    tooltip: 'marketInDepthValuation.avgSub1Std',
  },
  {
    value: 1,
    name: '+1 StDv',
    color: '#009d5b',
    tooltip: 'marketInDepthValuation.avgPlus1Std',
  },
  {
    value: 2,
    name: '+2 StDv',
    color: '#1d97ef',
    tooltip: 'marketInDepthValuation.avgPlus2Std',
  },
];

class LineSelect extends PureComponent {
  render() {
    const { onChange, activeLines } = this.props;
    return (
      <div className="check-list-inline">
        <div className="line-select list-check">
          {lines.map((line, index) => (
            <div key={line.value} className="checkbox">
              <PortalTooltip tooltip={I18n.t(line.tooltip)}>
                <input
                  id={`cb-${index}`}
                  type="checkbox"
                  checked={!!activeLines[line.value]}
                  onChange={e => onChange(e, line.value)}
                />
                <label htmlFor={`cb-${index}`}>
                  <a
                    style={{ backgroundColor: line.color }}
                    href="#"
                    className="badge text-white"
                  >
                    {line.name}
                  </a>
                </label>
              </PortalTooltip>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

LineSelect.propTypes = {};

LineSelect.defaultProps = {
  onChange: () => {},
};

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(LineSelect);
